import { ContactUsVm, ContactUsVmValidationRules } from './contact-us-vm';
import { Component, Vue } from 'vue-facing-decorator';
import { useVuelidate } from '@vuelidate/core';
import { reactive } from 'vue';

@Component({
  components: {
  }
})
export default class About extends Vue {

  vm = reactive<ContactUsVm>(new ContactUsVm());

  v$: any = useVuelidate(ContactUsVmValidationRules, this.vm);

  showFrom: boolean = true;
  showConfirmation: boolean = false;
  enableNewsLetterButton: boolean = true;
  subscribeButtonText: string = 'Send';

  async submitForm() {
    this.v$.$touch();
    var isValid: boolean = await this.v$.$validate();

    if (isValid) {
      this.subscribeButtonText = "sending ..."
      const result = await fetch(`/ContactUsApi/`, {
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(this.vm),
      });

      if(result.status == 200){
        this.showFrom = false;
        this.showConfirmation = true;
      }
      else{
        this.subscribeButtonText = "Send";
      }
    }
  }

}